import translation from 'locales/translation';
import React, { useCallback, useContext, useState } from 'react';
import { useSelector } from 'react-redux';

import { DialogIcon, SearchIcon, SyncIcon } from 'components/Icons';

import { IReducer } from 'store/Reducer';

import MensagensContext from 'pages/Assessor/MensagensAssessor/Context';
import {
  Button,
  ButtonThemes,
  IconButton,
  Input,
  Select,
} from 'plataforma-fundacao-componentes';

import { clsx } from 'helpers/utils/HTMLUtils';
import { toggleResponse } from '../Chat';
import ChatContext from '../Chat/ChatContext';
import './styles.scss';
const rootClassName = 'conversa-assessor-filtro';

interface Props {
  respondidos?: number;
  emResposta?: number;
  pendentes?: number;
}

enum FilterType {
  RESPONDIDO = 'respondido',
  PENDENTE = 'pendente',
  EM_RESPOSTA = 'emResposta',
}

let inputTimeout: number;

export default function Filtro({
  respondidos = 0,
  emResposta = 0,
  pendentes = 0,
}: Readonly<Props>) {
  const {
    pesquisar,
    filtroRespondidos,
    filtroEmResposta,
    irParaConversa,
    atualizarMensagens,
  } = useContext(MensagensContext);
  const { duvidaAtual, setDuvida } = useContext(ChatContext);
  const { loadingDuvidas } = useSelector(
    (state: IReducer) => state.assembleiasAssessor
  );
  const [valueSearch, setValueSearch] = useState<string | any>();
  const [valueSelect, setValueSelect] = useState<string | null>(null);

  const handleChange = useCallback(
    (event: any) => {
      const value = event;
      setValueSelect(value);

      if (!value) {
        filtroRespondidos(undefined);
        filtroEmResposta(undefined);
      } else if (
        value === FilterType.RESPONDIDO ||
        value === FilterType.PENDENTE
      ) {
        filtroRespondidos(value === FilterType.RESPONDIDO);
      } else if (value === FilterType.EM_RESPOSTA) {
        filtroEmResposta(value === FilterType.EM_RESPOSTA);
      }

      irParaConversa('');
    },
    [filtroEmResposta, filtroRespondidos, irParaConversa]
  );

  const handleSearch = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const term = event?.currentTarget?.value?.replace(/(\.|-)/g, '');
      setValueSearch(term);
      window.clearTimeout(inputTimeout);
      inputTimeout = window.setTimeout(() => {
        pesquisar(term.toUpperCase());
      }, 1000);
    },
    [pesquisar]
  );

  return (
    <div className={`${rootClassName}`}>
      <div className={`${rootClassName}-left`}>
        <Button
          theme={ButtonThemes.Secondary}
          onClick={() => {
            if (duvidaAtual) {
              toggleResponse(
                {
                  idDuvida: duvidaAtual?.idDuvidaFrequente,
                  flgEmEdicao: Boolean(duvidaAtual!?.resposta),
                  flgEmResposta: false,
                },
                () => {
                  atualizarMensagens(() => {
                    setDuvida(undefined);
                  });
                }
              );
            } else {
              atualizarMensagens();
            }
          }}
          leftIcon={<SyncIcon animated={loadingDuvidas} />}
          disabled={loadingDuvidas}
        >
          {translation.AssessorMensagens.atualizar}
        </Button>
      </div>
      <div
        className={clsx([
          `${rootClassName}-right`,
          `${rootClassName}-chips-wrapper`,
        ])}
      >
        <div
          className={clsx([
            `${rootClassName}-badge`,
            `${rootClassName}-respondido`,
          ])}
        >
          <DialogIcon />
          <span>{translation.AssessorMensagens.respondido(respondidos)}</span>
        </div>
        <div
          className={clsx([
            `${rootClassName}-badge`,
            `${rootClassName}-em-resposta`,
          ])}
        >
          <DialogIcon />
          <span>
            {translation.AssessorMensagens['em-resposta'](emResposta)}
          </span>
        </div>
        <div
          className={clsx([
            `${rootClassName}-badge`,
            `${rootClassName}-pendente`,
          ])}
        >
          <DialogIcon />
          <span>{translation.AssessorMensagens.pendente(pendentes)}</span>
        </div>
      </div>

      <div className={`${rootClassName}-input-container`}>
        <Input
          value={valueSearch}
          onChange={handleSearch}
          placeholder={translation.AssessorMensagens.search}
          rightObject={
            <IconButton
              onClick={() => {
                handleSearch({ currentTarget: { value: valueSearch } } as any);
              }}
              icon={<SearchIcon />}
            />
          }
        />
        <Select
          placeholder={translation.AssessorMensagens.filtrar}
          options={[
            {
              label: translation.AssessorMensagens['sem-filtro'],
              value: null,
            },
            {
              label: translation.AssessorMensagens.filtro.respondido,
              value: 'respondido',
            },
            {
              label: translation.AssessorMensagens.filtro.emResposta,
              value: 'emResposta',
            },
            {
              label: translation.AssessorMensagens.filtro.pendente,
              value: 'pendente',
            },
          ]}
          onChange={(evt) => {
            setValueSelect(evt);
            handleChange(evt);
          }}
          disabled={loadingDuvidas}
          value={valueSelect}
          preSelectUniqueOption
          clearButton={false}
        />
      </div>
    </div>
  );
}
